export default __webpack_public_path__ + "static/media/glrc-product.culinary.a3161414.png";